import { Grid } from "components/Grid";
import { SMALL, LARGE, FOUR_COLUMNS_GRID } from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import { PersonCard } from "components/PersonCard";
import { Spacing } from "components/Spacing";
import styles from "./PersonGrid.module.css";

export const PersonGrid = ({ departments, persons }) => (
  <div className={styles.container}>
    {(departments || []).filter(Boolean).map((department) => {
      const personsInDepartment = persons.filter(
        ({ departments }) =>
          departments.findIndex(({ name }) => name === department?.name) > -1
      );

      if (!personsInDepartment.length) return null;

      return (
        <Spacing size={SMALL} key={department?.slug}>
          <MaxWidth size={LARGE}>
            <h2 className={styles.title}>{department?.name}</h2>
            <Grid columns={FOUR_COLUMNS_GRID}>
              {personsInDepartment
                .filter(Boolean)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((person) => (
                  <PersonCard key={person?.slug?.current} {...person} />
                ))}
            </Grid>
          </MaxWidth>
        </Spacing>
      );
    })}
  </div>
);
